import { render, staticRenderFns } from "./NodeParagraph.vue?vue&type=template&id=d17002a4&scoped=true&"
import script from "./NodeParagraph.vue?vue&type=script&lang=js&"
export * from "./NodeParagraph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d17002a4",
  null
  
)

export default component.exports